import { getLogger } from "@/common//log";

export function inspectorLogger() {
	return getLogger("inspector");
}
